import React, { useRef, useState } from "react";
import styled from "styled-components";
import { ModuleLightBtn } from "storybook-components/Button";
import { GreenAnchor } from "storybook-components/Link";
import { Body } from "storybook-components/Typography";
import { MarketoSingleEmailFieldStyle } from "storybook-components/MarketoForm";
import Modal from "./Modal";
import MarketoForm from "./Marketo/MarketoForm";

const ModalBackground = styled.div`
  background-color: ${({ theme }) => theme.colors.green5};
  padding: 32px;
`;

const StyledBodyTxt = styled(Body)`
  color: ${({ theme }) => theme.colors.green1};
  margin-bottom: 24px;
`;

const NewsletterModalBtn = props => {
  const { successMessage, marketoFormId, buttonTxt, className } = props;
  const modalRef1 = useRef();
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  return (
    <>
      <ModuleLightBtn
        className={className}
        onClick={() => modalRef1.current.openModal()}
      >
        {buttonTxt}
      </ModuleLightBtn>
      <Modal ref={modalRef1}>
        {showSuccessMessage ? (
          successMessage
        ) : (
          <ModalBackground>
            <StyledBodyTxt>
              Get our weekly data newsletter and be notified about our new blog
              posts.
            </StyledBodyTxt>
            <MarketoSingleEmailFieldStyle>
              <MarketoForm
                formId={marketoFormId}
                onSuccessAnalyticsEvent="content_downloaded"
                customOnSuccessEvent={() => setShowSuccessMessage(true)}
              />
            </MarketoSingleEmailFieldStyle>
          </ModalBackground>
        )}
      </Modal>
    </>
  );
};

NewsletterModalBtn.defaultProps = {
  buttonTxt: "Sign up for the newsletter",
  successMessage: (
    <ModalBackground>
      <StyledBodyTxt>
        Thanks! While you’re waiting for the next issue of Analytics Dispatch,
        check out our whitepapers, webinars, and more on our{" "}
        <GreenAnchor href="/resources/">resource center. </GreenAnchor>
      </StyledBodyTxt>
    </ModalBackground>
  ),
  marketoFormId: 1035
};

export default NewsletterModalBtn;
